document.addEventListener('DOMContentLoaded', function() {
  const supportButton = document.querySelector('.floating-support__button');
  const supportMenu = document.getElementById('floating-support-menu');
  
  if (!supportButton || !supportMenu) return;
  
  // Toggle menu visibility
  supportButton.addEventListener('click', function(e) {
    e.stopPropagation();
    const isExpanded = this.getAttribute('aria-expanded') === 'true';
    this.setAttribute('aria-expanded', !isExpanded);
    supportMenu.setAttribute('aria-hidden', isExpanded);
  });
  
  // Close menu when clicking outside
  document.addEventListener('click', function(e) {
    if (!supportButton.contains(e.target) && !supportMenu.contains(e.target)) {
      supportButton.setAttribute('aria-expanded', 'false');
      supportMenu.setAttribute('aria-hidden', 'true');
    }
  });
  
  // Close menu when pressing Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && supportButton.getAttribute('aria-expanded') === 'true') {
      supportButton.setAttribute('aria-expanded', 'false');
      supportMenu.setAttribute('aria-hidden', 'true');
      supportButton.focus();
    }
  });
  
  // Close menu after clicking a link
  supportMenu.querySelectorAll('.floating-support__link').forEach(link => {
    link.addEventListener('click', function() {
      supportButton.setAttribute('aria-expanded', 'false');
      supportMenu.setAttribute('aria-hidden', 'true');
    });
  });
});